import api from "./client";

export async function login(identifier, password) {
  const value = String(identifier || "").trim();
  const res = await api.post("/auth/login", { email: value, username: value, password });
  return res.data.data;
}

export async function me() {
  const res = await api.get("/auth/me");
  return res.data.data;
}

